import { configureStore } from '@reduxjs/toolkit';
import { app } from './app.ts';
import { dose } from './dose.ts';
import { toasts } from './toasts.ts';

export const store = configureStore({
  reducer: { app, toasts, dose }
});